import { useApi } from "../../../swr/useApi";
import { productWarrantyTypesService } from "../../api_client";
import type { ProductWarrantyTypeDto } from "../../../api";

export function useProductWarrantyTypes() {
    return useApi<ProductWarrantyTypeDto[]>(
        "product-warranty-types",
        async () => {
            return await productWarrantyTypesService.getProductWarrantyTypes();
        }
    );
}


